import React, { useState } from 'react';
import { useLocation, useHistory } from 'react-router-dom';
import { connect } from 'react-redux';
import { Card, CardContent } from '@material-ui/core';
import FilterListIcon from '@material-ui/icons/FilterList';
import ClearIcon from '@material-ui/icons/Clear';
import {
  CommonButton,
} from '..';
import CommonTextField from '../CommonTextField';
import {
  getAllDeletedSites, getAllSites, getVendorSites, updateSearchQuery,
} from '../../redux/actions/sites';
import CommonSearch from '../CommonSearch';

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

const SitesFilter = ({
  cities, states, mediaTypes,
  getAllSitesAction, updateQuery, primaryQuery,
  currentLocation, setSelected, getVendorSitesFun, getDeleteSites,

}) => {
  const currentRoute = useLocation();
  const query = useQuery();
  const history = useHistory();
  const [site, setSiteId] = useState('')
  const [supplier, setSupplier] = useState('')
  const [location, setLocation] = useState('')
  const [mediaType, setMediaTypes] = useState(null)
  const [state, setStates] = useState(null)
  const [city, setCities] = useState(null)
  const [filtered, setFilter] = useState(false)

  const filterSites = async () => {
    if (site && site.trim()) {
      if (query.has('siteId')) {
        query.set('siteId', site.trim())
      } else {
        query.append('siteId', site.trim())
      }
    }
    if (supplier && supplier.trim()) {
      if (query.has('supplierName')) {
        query.set('supplierName', supplier.trim())
      } else {
        query.append('supplierName', supplier.trim())
      }
    }
    if (location && location.trim()) {
      if (query.has('locationName')) {
        query.set('locationName', location.trim())
      } else {
        query.append('locationName', location.trim())
      }
    }
    if (mediaType) {
      if (query.has('mediaTypeName')) {
        query.set('mediaTypeName', mediaType)
      } else {
        query.append('mediaTypeName', mediaType)
      }
    }
    if (state) {
      if (query.has('stateName')) {
        query.set('stateName', state)
      } else {
        query.append('stateName', state)
      }
    }
    if (city) {
      if (query.has('cityName')) {
        query.set('cityName', city)
      } else {
        query.append('cityName', city)
      }
    }
    setFilter(true)

    query.delete('page')
    await updateQuery(query.toString())
    history.push(currentLocation)
    const page = parseInt(query.get('page') || '1', 10);
    if (currentLocation === 'all-sites') { setSelected([]) }
    switch (currentLocation) {
      case 'all-sites':
      case 'sites-reported':
      case 'sites-comparison':
      case 'site-rapport-auditor':
      case 'assign-flex-date':
      case 'change-end-date':
      case 'proposed-photos':
        getAllSitesAction(page, primaryQuery, query.toString());
        break;
      case 'map-deleted-sites':
        getDeleteSites(page, primaryQuery, query.toString());
        break;
      case 'vendor-sites':
        getVendorSitesFun(page, query.toString());
        break;
      default:
        break;
    }
  }

  const clearFilters = () => {
    setSiteId('')
    setSupplier('')
    setLocation('')
    setMediaTypes(null)
    setStates(null)
    setCities(null)
    setFilter(false)
    

    const page = parseInt(query.get('page') || '1', 10);
    query.delete('page')
    updateQuery('')
    history.push(currentRoute.pathname);
    if (currentLocation === 'all-sites') { setSelected([]) }
    switch (currentLocation) {
      case 'all-sites':
      case 'sites-reported':
      case 'sites-comparison':
      case 'site-rapport-auditor':
      case 'assign-flex-date':
      case 'change-end-date':
      case 'proposed-photos':
        getAllSitesAction(page, primaryQuery, '');
        break;
      case 'map-deleted-sites':
        getDeleteSites(page, primaryQuery, '');
        break;
      case 'vendor-sites':
        getVendorSitesFun(page);
        break;
      default:
        break;
    }
  }

  const handleChangeCity = (val) => {
    if (val) { setCities(val.value) } else { setCities(val) }
  }

  const handleChangeStates = (val) => {
    if (val) { setStates(val.value) } else { setStates(val) }
  }

  const handleChangeMedia = (val) => {
    if (val) { setMediaTypes(val.value) } else { setMediaTypes(val) }
  }

  const filterDisabled = !site.trim()
    && !supplier.trim() && !location.trim() && !mediaType && !state && !city

  const userType = JSON.parse(localStorage.getItem('user'));

  return (
    <Card>
      <br />
      <CardContent>
        <div className="row">
          <div className="col-3">
            <CommonSearch label="Media" value={mediaType} data={mediaTypes} onChange={handleChangeMedia} />
          </div>
          <div className="col-3">
            <CommonSearch label="State" value={state} data={states} onChange={handleChangeStates} />
          </div>
          <div className="col-3">
            <CommonSearch label="City" value={city} data={cities} onChange={handleChangeCity} />
          </div>
          <div className="col-3">
            <CommonTextField label="Location" value={location} placeholder="Location" handleChange={setLocation} />
          </div>
        </div>
        <br />
        <div className="row">
          {userType && (userType.userType === 'admin' || userType.userType === 'manager')
            ? (
              <div className="col-3">
                <CommonTextField label="Vendor" value={supplier} placeholder="Vendor Name" handleChange={setSupplier} />
              </div>
            )
            : null}
          <div className="col-3">
            <CommonTextField label="Site" value={site} placeholder="Site Id" handleChange={setSiteId} />
          </div>
        </div>
        <br />
        <div className="row">
          <div className="col-3">
            <CommonButton
              className="wide-200"
              variant="outlined"
              color="primary"
              disabled={filterDisabled}
              startIcon={<FilterListIcon />}
              onClick={filterSites}
            >
              Filter Sites
            </CommonButton>
          </div>
          <div className="col-3">
            <CommonButton
              className="wide-200"
              variant="outlined"
              color="secondary"
              disabled={filterDisabled && !filtered}
              startIcon={<ClearIcon />}
              onClick={clearFilters}
            >
              Clear Filters
            </CommonButton>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};

const mapState = (state) => ({
  cities: state.sites.cities,
  states: state.sites.states,
  mediaTypes: state.sites.mediaTypes,
  primaryQuery: state.sites.primaryQuery,
});

const mapActions = {
  getAllSitesAction: getAllSites,
  getVendorSitesFun: getVendorSites,
  updateQuery: updateSearchQuery,
  getDeleteSites: getAllDeletedSites,
};

export default connect(mapState, mapActions)(SitesFilter);
